import firebase from "firebase/app"
import 'firebase/firestore'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDAE-kH_i-tjxdG1QXTn0TESkwlZLHHLT4",
    authDomain: "cs-education-portfolio.firebaseapp.com",
    projectId: "cs-education-portfolio",
    storageBucket: "cs-education-portfolio.appspot.com",
    messagingSenderId: "287305438883",
    appId: "1:287305438883:web:cc78e05af74a0ad26d1116",
    measurementId: "G-F79BCL77BZ"
  };

// init firebase
firebase.initializeApp(firebaseConfig)

// init services
const projectFirestore = firebase.firestore()

export { projectFirestore }